import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
  Signal,
  inject,
} from '@angular/core';

import { Carousel } from 'primeng/carousel';
import { PublicBoxesCarouselTileComponent } from '../public-boxes-carousel-tile/public-boxes-carousel-tile.component';
import {
  BreakpointService,
  ResponsiveCarouselOptions,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicBox } from '../../models/public-box';

@Component({
  selector: 'app-public-boxes-carousel',
  imports: [Carousel, PublicBoxesCarouselTileComponent, SpinnerFilledComponent],
  templateUrl: './public-boxes-carousel.component.html',
  styleUrl: './public-boxes-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxesCarouselComponent {
  private readonly breakpoint = inject(BreakpointService);

  public readonly boxes = input.required<PublicBox[]>();

  protected readonly shouldShowAsCarousel = this.shouldShowAsCarouselSignal();
  protected readonly responsiveOptions = this.responsiveOptionsSignal();

  private shouldShowAsCarouselSignal(): Signal<boolean> {
    const moreThanLimitSignal = this.moreThanLimitSignal();
    const isMobileSignal = this.isMobileSignal();

    return computed(() => moreThanLimitSignal() || isMobileSignal());
  }

  private isMobileSignal(): Signal<boolean> {
    return toSignal(this.breakpoint.observe('max-sm'), {
      initialValue: false,
    });
  }

  private moreThanLimitSignal(): Signal<boolean> {
    const limit = 3;

    return computed(() => this.boxes().length > limit);
  }

  private responsiveOptionsSignal(): Signal<ResponsiveCarouselOptions[]> {
    return signal([
      {
        breakpoint: '1024px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
    ]);
  }
}
